module.exports = __webpack_public_path__ + "img/icon-download.88e39013.svg";